var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOne01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "78.398 172.16 16 16",
    enableBackground: "new 78.398 172.16 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#13392B",
    d: "M86.398,172.16c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S90.809,172.16,86.398,172.16z  M86.398,187.16c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S90.257,187.16,86.398,187.16z M87.263,175.367 c-0.186-0.078-0.396-0.042-0.541,0.095l-2.143,2.008c-0.201,0.188-0.212,0.505-0.023,0.706c0.19,0.203,0.506,0.213,0.707,0.023 l1.301-1.219v7.013c0,0.276,0.224,0.5,0.5,0.5s0.5-0.224,0.5-0.5v-8.167C87.564,175.627,87.446,175.447,87.263,175.367z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOne01);
export default __webpack_public_path__ + "static/media/icon_one-01.6ec57e300be305af8a804998eef3f8bc.svg";
export { ForwardRef as ReactComponent };